module.exports = __webpack_public_path__ + "img/888.7e1d4411.png";